<template>
  <div :class="{ 'dark-mode': isDarkMode }" class="carousel" @wheel="handleScroll" @touchstart="handleTouchStart"
    @touchmove="handleTouchMove" @touchend="handleTouchEnd">
    <div class="carousel-inner" :style="{ transform: `translateX(-${slideStoreIndex * 100}%)` }">
      <div class="carousel-item" v-for="(slide, index) in slides" :key="index" :style="slideCaptionVars(slide)">
        <img :src="slideMainImage(slide, index)" :alt="slide.alt" loading="lazy">
        <div class="overlay"></div>
        <div class="caption">
          <img :src="slide.logo" :alt="slide.alt">
          <p v-if="slide.h2" class="title">{{ slide.h2 }}</p>
        </div>
        <div class="description">
          <p>{{ translations[slide.description]?.desc }}</p>
        </div>
      </div>
    </div>
    <div class="carousel-controls">
      <div class="carousel-control prev">
        <button class="carousel-control" @click="stepPrev">❮</button>
      </div>
      <div class="carousel-control next">
        <button class="carousel-control" @click="stepNext">❯</button>
      </div>
    </div>
    <div class="carousel-indicators-wrap">
      <div v-if="currentInnerCount > 1" class="carousel-sub-indicators" role="tablist"
        :aria-label="'Zdjęcia w slajdzie'">
        <span v-for="i in currentInnerCount" :key="i" role="tab" :aria-selected="i - 1 === innerIndex"
          :class="{ active: i - 1 === innerIndex }" @click="goToInner(i - 1)" />
      </div>
      <div class="carousel-indicators">
        <span v-for="(slide, index) in slides" :key="index" :class="{ active: index === slideStoreIndex }"
          @click="goToSlide(index)"></span>
      </div>
    </div>
  </div>
</template>


<script>
import { useSlideStore } from '../../store/slideStore';
import { computed } from 'vue';
import translationsData from '@/assets/text_lang/translations.json';
import { useLanguageStore } from '@/theme';
export default {
  data() {
    return {
      innerIndex: 0,
      lastScroll: 0,
      touchStartX: 0,
      touchEndX: 0,
    }
  },
  setup() {
    const slideStore = useSlideStore();
    const languageStore = useLanguageStore();

    const translations = computed(() => {
      return translationsData[languageStore.currentLanguage]["portfolio"];
    });

    const slides = computed(() => [
      {
        alt: 'image 2',
        description: 'angels_envy',
        darkMode: false,
        logo: 'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/logo/Angels-Envy.webp',
        logoMaxWidth: 500,
        captionWidth: 500,
        captionTop: '25%',
        captionWidthMobile: 300,
        innerImages: [
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/angels-envy-okladka.webp',
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/AE-95 (1).webp',
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/AE-38 (1).webp',
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/AE-169 (1).webp'
        ]
      },
      {
        image: 'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/belvedere-okladka.webp',
        alt: 'image 3',
        description: 'belvedere',
        darkMode: false,
        logo: 'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/logo/belvedere.webp',
        logoMaxWidth: 600,
        captionWidth: 600,
        captionTop: '25%',
        captionWidthMobile: 300,
        innerImages: [
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/belvedere-okladka.webp',
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/BLVD Summit-110 (1).webp',
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/BLVD Summit-117 (1).webp',
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/Belvedere Base Camp March 2026 86.webp',
        ]
      },
      {
        image: 'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/bombay-sapphire-okladka.webp',
        alt: 'image 4',
        description: 'bombay_sapphire',
        darkMode: false,
        logo: 'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/logo/Bombay-Sapphire.webp',
        captionWidth: 330,
        captionTop: '25%',
        captionWidthMobile: 200,
        innerImages: [
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/bombay-sapphire-okladka.webp',
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/_T5A0661.webp',
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/_T5A0776 (1).webp',
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/_T5A1330 (3).webp'
        ]
      },
      {
        image: 'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/boss-okladka.webp',
        alt: 'image 5',
        description: 'boss',
        darkMode: false,
        logo: 'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/logo/boss.webp',
        logoMaxWidth: 500,
        captionWidth: 500,
        captionTop: '25%',
        captionWidthMobile: 250,
        innerImages: [
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/boss-okladka.webp',
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/Alexey_pilipenko 0040 (1).webp',
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/Alexey_pilipenko 0298 (1).webp',
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/Alexey_pilipenko 0303.webp',
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/Alexey_pilipenko 0361 (1).webp',
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/Alexey_pilipenko 0368 (1).webp',
        ]
      },
      {
        image: 'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/dewar-okladka.webp',
        alt: 'image 6',
        description: 'dewars',
        darkMode: false,
        logo: 'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/logo/Dewars.webp',
        logoMaxWidth: 400,
        captionWidth: 400,
        captionTop: '25%',
        captionWidthMobile: 230,
        innerImages: [
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/dewar-okladka.webp',
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/_T5A5972 (1).webp',
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/_T5A6042 (2).webp',
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/_T5A6070 (2).webp',
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/_T5A6162 (2).webp',
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/_T5A6548 (1).webp',
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/_T5A6959.webp',
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/_T5A7046 (1).webp',
        ]
      },
      {
        image: 'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/Alexey_Pilipenko_0395.webp',
        alt: 'image 1',
        description: 'douglas',
        darkMode: false,
        logo: 'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/logo/Douglas.png',
        logoMaxWidth: 600,
        captionWidth: 600,
        captionTop: '25%',
        captionWidthMobile: 300,
        innerImages: [
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/Alexey_Pilipenko_0395.webp',
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/Alexey_Pilipenko_0153.webp',
        ]
      },
      {
        image: 'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/glenfiddich-grand-y-okladka.webp',
        alt: 'image 7',
        h2: 'Grand Yozakura',
        description: 'glenfiddich_grand_yozakura',
        darkMode: false,
        logo: 'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/logo/Glenfiddich_1.webp',
        captionWidth: 300,
        captionTop: '25%',
        captionWidthMobile: 180,
        innerImages: [
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/glenfiddich-grand-y-okladka.webp',
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/Glenfiddich Dinner 013 (1).webp',
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/Glenfiddich Dinner 017 (1).webp',
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/Glenfiddich Dinner 089 (1).webp',
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/Glenfiddich Dinner 110.webp',
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/Glenfiddich Dinner 114 (1).webp',
        ]
      },
      {
        image: 'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/glenfiddich-time-r-okladka.webp',
        alt: 'image 8',
        h2: 'Time reimagined',
        description: 'glenfiddich_time_reimagined',
        darkMode: false,
        logo: 'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/logo/Glenfiddich_1.webp',
        captionWidth: 300,
        captionTop: '25%',
        captionWidthMobile: 180,
        innerImages: [
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/glenfiddich-time-r-okladka.webp',
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/Glenfiddich-17.webp',
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/Glenfiddich-266 (1).webp',
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/Glenfiddich-27 (3).webp',
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/Glenfiddich-29 (1).webp',
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/Glenfiddich-31 (1).webp',
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/Glenfiddich-35 (2).webp',
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/Glenfiddich-38 (3).webp',
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/Glenfiddich-4.webp',
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/Glenfiddich-45.webp',
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/Glenfiddich-70 (2).webp',
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/Glenfiddich-8 (1).webp',
        ]
      },
      {
        image: 'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/glenfiddich-x-andre-okladka.webp',
        alt: 'image 9',
        h2: 'X Andre',
        description: 'glenfiddich_x_andre',
        darkMode: false,
        logo: 'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/logo/Glenfiddich_1.webp',
        captionWidth: 300,
        captionTop: '25%',
        captionWidthMobile: 180,
        innerImages: [
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/glenfiddich-x-andre-okladka.webp',
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/image00058.webp',
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/image00175 (1).webp',
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/image00206 (3).webp',
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/image00238.webp',
        ]
      },
      {
        image: 'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/jim-beam-letnie-b-okladka.webp',
        alt: 'image 10',
        h2: 'Letnie brzmienie',
        description: 'jim_beam_letnie_brzmienie',
        darkMode: false,
        logo: 'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/logo/Jim-Beam.webp',
        captionWidth: 250,
        captionTop: '25%',
        captionWidthMobile: 180,
        innerImages: [
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/jim-beam-letnie-b-okladka.webp',
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/IMG_7664.webp',
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/IMG_7698.webp',
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/IMG_8026 (1).webp',
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/IMG_8538 (3).webp',
        ]
      },
      {
        image: 'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/makers-mark-okladka.webp',
        alt: 'image 11',
        description: 'makers_mark',
        darkMode: false,
        logo: 'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/logo/Makers-Mark.webp',
        captionWidth: 300,
        captionTop: '25%',
        captionWidthMobile: 180,
        innerImages: [
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/makers-mark-okladka.webp',
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/Mm-142 (1).webp',
          'https://products-rent-cocktailservice.s3.eu-central-1.amazonaws.com/portfolio/Mm-43 (2).webp',
        ]
      }
    ]);

    if (slideStore.slideIndex >= slides.value.length) {
      slideStore.setSlideIndex(0);
    }
    const slideStoreIndex = computed(() => slideStore.slideIndex);

    return {
      currentLanguage: languageStore.currentLanguage,
      translations,
      slideStoreIndex,
      slides
    };
  },
  computed: {
    isDarkMode() {
      if (!this.slides || !this.slides[this.slideStoreIndex]) {
        return false;
      }
      return this.slides[this.slideStoreIndex].darkMode ?? false;
    },
    currentInnerCount() {
      const s = this.slides[this.slideStoreIndex];
      // const n = s?.imageEven;
      const n = s.innerImages.length;
      console.log(n);
      return typeof n === 'number' && n > 1 ? n : 0;
    },
  },
  watch: {
    slideStoreIndex() {
      this.innerIndex = 0;
    },
  },
  methods: {
    slideMainImage(slide, index) {
      if (index !== this.slideStoreIndex) return slide.image;
      const imgs = slide.innerImages;
      if (Array.isArray(imgs) && imgs.length > 0 && this.innerIndex < imgs.length) {
        return imgs[this.innerIndex];
      }
      return slide.image;
    },
    goToInner(i) {
      this.innerIndex = i;
    },
    handleTouchStart(event) {
      const x = event.touches[0].clientX;
      this.touchStartX = x;
      this.touchEndX = x;
    },
    handleTouchMove(event) {
      this.touchEndX = event.touches[0].clientX;
    },
    handleTouchEnd() {
      const swipeThreshold = 50;
      const start = this.touchStartX ?? 0;
      const end = this.touchEndX ?? start;
      if (start - end > swipeThreshold) {
        this.stepNext();
      } else if (end - start > swipeThreshold) {
        this.prevSlide();
      }
      this.touchStartX = 0;
      this.touchEndX = 0;
    },
    stepNext() {
      if (this.innerIndex < this.currentInnerCount - 1) {
        // Jeśli są jeszcze zdjęcia wewnątrz tego slajdu -> idź do następnego wewnętrznego
        this.innerIndex++;
      } else {
        // Jeśli to było ostatnie zdjęcie -> idź do następnego głównego slajdu
        this.nextSlide();
        // innerIndex wyzeruje się automatycznie przez watcher (już go masz w kodzie)
      }
    },

    // GŁÓWNA LOGIKA: Krok do tyłu
    stepPrev() {
      if (this.innerIndex > 0) {
        // Jeśli nie jesteśmy na pierwszym wewnętrznym -> cofnij o jedno
        this.innerIndex--;
      } else {
        // Jeśli jesteśmy na pierwszym -> idź do poprzedniego głównego slajdu
        const oldIndex = this.slideStoreIndex;
        this.prevSlide();

        // WAŻNE: Po zmianie slajdu na poprzedni, chcemy pokazać OSTATNIE zdjęcie z tego nowego slajdu
        if (oldIndex !== this.slideStoreIndex) {
          this.$nextTick(() => {
            this.innerIndex = this.currentInnerCount > 0 ? this.currentInnerCount - 1 : 0;
          });
        }
      }
    },
    nextSlide() {
      const slideStore = useSlideStore();
      if (this.slideStoreIndex == this.slides.length - 1) {
        slideStore.setSlideIndex(0);
        this.$router.push('/contact');
      }
      else {
        slideStore.setSlideIndex((this.slideStoreIndex + 1) % this.slides.length);
      }
    },
    prevSlide() {
      const slideStore = useSlideStore();
      if (this.slideStoreIndex == 0) {
        slideStore.setSlideIndex(5);
        this.$router.push('/event');
      } else {
        slideStore.setSlideIndex((this.slideStoreIndex - 1 + this.slides.length) % this.slides.length);
      }
    },
    goToSlide(index) {
      const slideStore = useSlideStore();
      slideStore.setSlideIndex(index);
      this.innerIndex = 0;
    },
    /** Opcjonalnie na slajdzie: captionWidth (px), logoMaxWidth (px), captionTop (np. 25 lub '30%'). */
    slideCaptionVars(slide) {
      const vars = {};
      if (slide.captionWidth != null) {
        vars['--caption-width'] = typeof slide.captionWidth === 'number' ? `${slide.captionWidth}px` : slide.captionWidth;
      }
      if (slide.captionWidthMobile != null) {
        vars['--caption-width-mobile'] = typeof slide.captionWidthMobile === 'number' ? `${slide.captionWidthMobile}px` : slide.captionWidthMobile;
      }
      if (slide.logoMaxWidth != null) {
        vars['--logo-max-width'] = typeof slide.logoMaxWidth === 'number' ? `${slide.logoMaxWidth}px` : slide.logoMaxWidth;
      }
      if (slide.captionTop != null) {
        vars['--caption-top'] = typeof slide.captionTop === 'number' ? `${slide.captionTop}%` : slide.captionTop;
      }
      return vars;
    },
    handleScroll(event) {
      const currentTime = new Date().getTime();
      if (currentTime - this.lastScroll < 500) {
        return;
      }
      this.lastScroll = currentTime;
      if (event.deltaY > 0) {
        this.stepNext();
      } else {
        this.stepPrev();
      }
    }
  }
}
</script>

<style scoped>
.overlay {
  background: rgba(0, 0, 0, 0.5);
  /* Przezroczysta warstwa */
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}


.carousel {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  letter-spacing: 5px;
}

.carousel-inner {
  display: flex;
  transition: transform 0.5s ease;
}

.carousel-item {
  min-width: 100%;
  height: 100vh;
  position: relative;
  --caption-width: 330px;
  --caption-top: 25%;
}

/* Tylko zdjęcie tła — nie logo w .caption (wcześniej psuło widok mobilny) */
.carousel-item>img {
  margin-top: 100px;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.caption {
  position: absolute;
  white-space: pre-line;
  top: var(--caption-top);
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: left;
  width: var(--caption-width);
}

.caption img {
  width: auto;
  max-width: min(var(--logo-max-width, 100%), 100%);
  height: auto;
  display: block;
  margin-top: 0;
  margin-inline: auto;
}

.caption p {
  text-align: center;
}

.caption p.title {
  font-weight: bold;
  text-transform: uppercase;
  margin-bottom: 10px;
}

.description {
  position: absolute;
  bottom: 120px;
  left: 30%;
  transform: translateX(-50%);
  width: 50%;
  max-width: 800px;
  text-align: left;
  color: var(--dark-color-font);
  pointer-events: none;
}

.description p {
  font-size: 1.1rem;
  line-height: 1.8;
  text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.6);
}

.dark-mode .caption,
.dark-mode .description {
  color: var(--dark-color-background);
}

.carousel-controls {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  pointer-events: none;
}

.carousel-control {
  background: none;
  border: none;
  font-size: 3rem;
  /* Adjust font size as needed */
  color: var(--dark-color-font);
  cursor: pointer;
  pointer-events: all;
}

.dark-mode .carousel-control {
  color: var(--dark-color-background);
}

.carousel-control.prev {
  width: 50%;
}

.carousel-control.prev button {
  display: flex;
  justify-content: flex;
  margin-left: 15px;
  width: 40px;
}

.carousel-control.next {
  display: flex;
  justify-content: flex-end;
  width: 50%;

}

.carousel-control.next button {
  margin-right: 15px;
  width: 40px;
}


/* Szerokość bloku = rząd kropek; prostokąty rozciągają się na całą tę szerokość (inline-grid). */
.carousel-indicators-wrap {
  position: absolute;
  bottom: 30px;
  margin-bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  display: inline-grid;
  justify-items: stretch;
  gap: 10px;
  width: max-content;
}

.carousel-sub-indicators {
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 0;
  gap: 10px;
}

.carousel-sub-indicators span {
  display: block;
  flex: 1 1 0;
  min-width: 0;
  height: 12px;
  box-sizing: border-box;
  background-color: transparent;
  border: 3px solid var(--dark-color-font);
  cursor: pointer;
  border-radius: 2px;
}

.dark-mode .carousel-sub-indicators span {
  border: 3px solid var(--dark-color-background);
}

.carousel-sub-indicators span.active {
  background-color: var(--dark-color-font);
}

.dark-mode .carousel-sub-indicators span.active {
  background-color: var(--dark-color-background);
}

.carousel-indicators {
  display: flex;
}

.carousel-indicators span {
  width: 20px;
  height: 20px;
  background-color: transparent;
  border: 3px solid var(--dark-color-font);
  margin: 0 5px;
  cursor: pointer;
}

.dark-mode .carousel-indicators span {
  border: 4px solid var(--dark-color-background);
}

.carousel-indicators span.active {
  background-color: var(--dark-color-font);
}

.dark-mode .carousel-indicators span.active {
  background-color: var(--dark-color-background);
}

.hero-button {
  text-align: center;
  font-size: 20px;
  margin-top: 30px;
  width: 40%;
  height: 65px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--dark-color-font);
  color: var(--dark-color-background);
  padding: 10px 20px;
  text-decoration: none;
  transition: background 0.3s, color 0.3s;
  border: 2px solid transparent;
}

.dark-mode .hero-button {
  background: var(--dark-color-background);
  color: var(--dark-color-font);
}

.hero-button:hover {
  background: var(--dark-color-background);
  color: var(--dark-color-font);
  border: 2px solid var(--dark-color-font);
}

.dark-mode .hero-button:hover {
  background: var(--dark-color-font);
  color: var(--dark-color-background);
  border: 2px solid var(--dark-color-background);
}

@media (max-width: 1400px) {

  .caption p {
    font-size: 12px;
    line-height: 14pt;
  }

  .caption p.title {
    font-size: 18px;
    line-height: 18pt;
  }

  .hero-button {
    font-size: 15px;
  }

  .carousel-item>img {
    padding-top: 0px;
    margin-top: 80px;
  }
}

@media (max-width: 822px) {


  .carousel-controls {
    display: none;
    /* hidden */
    visibility: hidden;
  }

  .caption {
    top: 25%;
    left: 50%;
    width: var(--caption-width-mobile);
    padding-inline: 8px;
    box-sizing: border-box;
  }

  .caption img {
    width: var(--caption-width-mobile);
  }

  .carousel-item>img {
    padding-top: 0px;
    margin-top: 80px;
  }

  .description {
    bottom: 100px;
    left: 30%;
    width: 50%;
    max-width: 800px;
    text-align: left;
  }

  .description p {
    font-size: 0.8rem;
    line-height: 1.2;
  }

  .hero-button {
    font-size: 14px;
    width: 70%;
  }

  .carousel-control {
    font-size: 1.5rem;
  }

  .carousel-control.prev button {
    margin-left: 10px;
  }


  .carousel-control.next button {
    margin-right: 10px;
  }

  .carousel-indicators-wrap {
    bottom: 15px;
    margin-bottom: 15px;
    gap: 8px;
  }

  .carousel-sub-indicators {
    gap: 6px;
  }

  .carousel-sub-indicators span {
    height: 10px;
    border-width: 2px;
  }

  .carousel-indicators span {
    width: 15px;
    height: 15px;
    margin: 0 3px;
  }

}

@media (max-height: 1200px) and (min-width: 1401px) {

  .caption {
    top: 30%;
  }

  .caption p {
    font-size: 16px;
    line-height: 16pt;
    letter-spacing: 2px;
    text-align: center;
  }

  .description p {
    font-size: 1rem;
  }

  .caption p.title {
    font-size: 20px;
    line-height: 18pt;
  }
}
</style>